export default {
  'oddsFormat': {
    'default':'decimal',
    'GBR': 'fractional'
  },
  'streamingAllowedForPlayer': true,
  'racingMode': false,
  'enableFreeBets': false
};
